import { createStyles, makeStyles } from '@material-ui/styles';
import { yellow } from '../../../../theme/colors';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    alert: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      padding: '10px',
      border: `2px solid ${yellow}`,
      borderRadius: '10px'
    },
    link: {
      color: palette.text.primary,
      textDecoration: 'none',
      '@media (max-width: 724px)': {
        textDecoration: 'underline'
      },
      '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
